var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJ7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.27 21.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-J7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1262161237104",
    "data-name": 1262161237104
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.68.29c-6.11,1.15-9.41,4.56-13,8.26C-.41,10.69-.6,10.8,1.41,12.9c4.78,5,10.92,10.4,19.3,8.51,5.19-1.17,9.58-4.68,12.84-8.25,1.61-1.76,2.78-2.11.25-4.35S30,4.57,26,2.42c-3.4-1.83-6.8-3-11.36-2.13Zm.91,2.78C5.08,5.94,9.41,21.45,19.78,18.69,29.94,16,26,.24,15.59,3.07Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.84,9.31c-.79-.24-2.24,2.16-5.07.38C17.2,8.71,17,6.46,18,4.51a6.36,6.36,0,0,0-4.67,11.1c4.34,4.21,12.14,0,10.49-6.3Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ7);
export default __webpack_public_path__ + "static/media/J7.3a95aca9ba2344990bba0c0d46661b56.svg";
export { ForwardRef as ReactComponent };